import { IHinhThucNopTienReducer } from "../../reducer-model/category/IHinhThucNopTienReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IAccHinhThucNopTienActionTypes } from "./../../action-types/category/IAccHinhThucNopTien";
const iniState: IHinhThucNopTienReducer = {
  status: eReducerStatusBase.is_not_initialization,
  hinhThucNopTiens: [],
};
export const hinhThucNopTienReducer = (
  state: IHinhThucNopTienReducer = iniState,
  action: IAccHinhThucNopTienActionTypes
): IHinhThucNopTienReducer => {
  switch (action.type) {
    case "HINH_THUC_NOP_TIEN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "HINH_THUC_NOP_TIEN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        hinhThucNopTiens: action.payload.sort((a, b) => a.order - b.order),
      };
    case "HINH_THUC_NOP_TIEN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_NOP_TIEN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HINH_THUC_NOP_TIEN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "HINH_THUC_NOP_TIEN_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_NOP_TIEN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "HINH_THUC_NOP_TIEN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "HINH_THUC_NOP_TIEN_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_NOP_TIEN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        hinhThucNopTienEditing: action.payload,
      };
    case "HINH_THUC_NOP_TIEN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        hinhThucNopTienEditing: undefined,
      };
    default:
      return state;
  }
};
